<template>
  <div>
    <ui-v ref="reg-form" :rules="rules" v-if="showReg">
      <ui-heading tag="h4" bold bullet margin>{{
        $t("signUpTitle")
        }}</ui-heading>
      <ui-input name="email" @keyup.enter.native="doReg" type="email" v-model="user.email" :placeholder="$t('typeEmailHere')">
        <ui-icon slot="prefix" name="icon-idcard"></ui-icon>
      </ui-input>
      <ui-input name="password" @keyup.enter.native="doReg" v-model="user.password" type="password" :placeholder="$t('typePasswordHere')">
        <ui-icon slot="prefix" name="lock"></ui-icon>
      </ui-input>
      <ui-button full type="primary" :loading="loading" @click.native="doReg">{{
        $t("signup")
        }}</ui-button>
      <div class="mb20"></div>
      <p v-if="showResetLink" class="color pointer" @click="resetPassword">
        <ui-icon name="icon-info-circle-fill"></ui-icon>{{ $t("thirdPartyRegistered", { provider: provider }) }}
      </p>
      <p v-if="siteConfig.providers.google" class="pointer" @click="authenticate('google')">
        <ui-icon name="google"></ui-icon>Sign up using Google
      </p>
      <!-- <p>{{$t('thirdPartyLogin',{provider:provider})}}</p> -->
    </ui-v>
    <activation-form :email="user.email" v-if="showActivation"></activation-form>
  </div>
</template>
<script>
import api from "../../api/index";
import config from "../../config.js";
const siteConfig = config[process.env.NODE_ENV];
const defaultLang = siteConfig.defalultLang;
import { renderProviderLink } from "../../utils/utils.js";
import { mapGetters } from 'vuex'
import ActivationForm from "./ActivationForm.vue";
export default {
  data() {
    return {
      siteConfig: siteConfig,
      googleBtnLoading: false,
      showResetLink: false,
      showActivation: false,
      provider: "",
      showReg: true,
      user: {
        email: "",
        password: ""
      },
      loading: false,
      rules: {
        email: [{
          type: "email",
          trigger: "submit",
          message: this.$t("typeValidEmail")
        }, {
          type: "required",
          trigger: "submit",
          message: this.$t("empty") + this.$t("email")
        }],
        password: [{
            type: "required",
            trigger: "submit",
            message: this.$t("empty") + this.$t("password")
          },
          {
            type: "minLength",
            length: 6,
            trigger: "submit",
            message: this.$t("password") + this.$t("tooShort", { len: 6 })
          }
        ]
      }
    };
  },
  computed: {
    ...mapGetters(['lang'])
  },
  components: {
    ActivationForm
  },
  methods: {
    resetPassword() {
      api
        .forgotPassword({ email: this.user.email })
        .then(response => {
          this.$UiToast({
            message: this.$t("emailSendSuccess"),
            type: "success"
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    authenticate(provider) {
      this.googleBtnLoading = true;
      window.location.href = renderProviderLink(provider);
    },
    closeAlert() {
      this.emailInactived = false;
      this.user.email = "";
    },
    doReg() {
      this.$refs["reg-form"]
        .validate()
        .then(data => {
          this.reg();
        })
        .catch(err => {});
    },
    reg() {
      let user = {
        email: this.user.email,
        password: this.user.password,
        lang: this.lang
      };
      this.loading = true;
      localStorage.setItem("email", this.user.email);
      api
        .doReg(user)
        .then(response => {
          this.showActivation = true;
          this.showReg = false;
        })
        .catch(error => {
          this.loading = false;
          if (error.response) {
            let errorMsg = error.response.data.errorMsg;
            if (errorMsg == "alreadyExist") {
              this.$refs["reg-form"].parseError({
                name: "email",
                message: this.$t("alreadyRegistered")
              });
            }
            if (errorMsg == "thirdPartyUserExist") {
              this.showResetLink = true;
              this.provider = error.response.data.provider;
            }
          } else {
            throw new Error(error);
          }
        });
    }
  }
};

</script>
